import styled from 'styled-components';
import { body2, colors, fontWeights, spacing } from 'ui/theme';

export const CheckboxDescription = styled.p<{ isDisabled?: boolean }>`
  ${body2}
  cursor: default;
  grid-area: content;
  ${(props) => (props.isDisabled ? `color: ${colors.textDisabled};` : '')}
`;

export const LabelRow = styled.div`
  align-items: center;
  display: inline-flex;
  & > label {
    margin-bottom: 0;
  }
  & > span {
    color: ${colors.textSecondary};
    font-weight: ${fontWeights.regular};
    margin-right: ${spacing.half};
  }
`;

export const CheckboxRow = styled.div`
  display: flex;
  & > *:first-child {
    margin-right: ${spacing.half};
    margin-top: ${spacing.quarter};
  }
`;
